export enum VisitStatus {
    None = 0,
    Opened = 1,
    Closed = 2,
    Canceled = 3,
    Admitted = 4,
}
